@if ($output().tag) {
    @switch ($output().tag) {
        @case('span') {
            <span [innerHTML]="$output().value | sanitize:'bypassSecurityTrustHtml'"></span>
        }
        @case('p') {
            <p [innerHTML]="$output().value | sanitize:'bypassSecurityTrustHtml'"></p>
        }
    }
}